// src/services/firestoreService.js
import { collection, addDoc, getDocs, doc, deleteDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

const streetCollection = collection(db, 'streets');

export const saveStreet = async (street, type) => {
  try {
    await addDoc(streetCollection, { ...street, type });
  } catch (error) {
    console.error('Error adding document: ', error);
  }
};

export const fetchStreets = async () => {
  const querySnapshot = await getDocs(streetCollection);
  const streets = [];
  querySnapshot.forEach((doc) => {
    streets.push({ ...doc.data(), id: doc.id });
  });
  return streets;
};

export const deleteStreet = async (id) => {
  try {
    await deleteDoc(doc(db, 'streets', id));
  } catch (error) {
    console.error('Error deleting document: ', error);
  }
};


